import { atomWithReset } from 'jotai/utils'
import { LightAssistantWithPermissions } from '../../../model/User'

export const assistantPermissionsForm = atomWithReset<LightAssistantWithPermissions[]>([])
